import React from 'react';
import { useOffline } from '@/lib/OfflineContext';
import { Wifi, WifiOff } from 'lucide-react';
import { cn } from '@/lib/utils';

export default function OfflineIndicator() {
  const { isOnline, storageInfo } = useOffline();

  if (isOnline) return null;

  return (
    <div className="fixed bottom-4 left-4 z-50 animate-in fade-in slide-in-from-bottom-4">
      <div className="bg-amber-500 text-white rounded-lg p-3 shadow-lg flex items-center gap-3 max-w-xs">
        <WifiOff className="w-5 h-5 flex-shrink-0" />
        <div className="flex-1">
          <p className="font-semibold text-sm">Offline Mode</p>
          <p className="text-xs text-amber-100">
            {storageInfo?.items || 0} datasets cached • {storageInfo?.sizeInMB || 0}MB
          </p>
        </div>
      </div>
    </div>
  );
}